import * as React from "react";
import { actionCreators } from "page/calendar/store";
import { RubberBandItem, CalendarState } from "burde";
import ZentaColorPicker, {
    ZentaColorPickerItem,
} from "layout/common/controls-area/zenta-color-picker";
import { actionCreators as uiActionCreators } from "ui/store";
import { DefaultRubberbandsList } from "ui/constants";
import * as styles from "./cover-rubberband-picker.css";

type CoverRubberbandPickerProps = {
    validRubberBands: Array<RubberBandItem>;
    calendar: CalendarState;
    Binding_Rubberband: string;
} & typeof actionCreators &
    typeof uiActionCreators;

interface CoverRubberbandPickerState {}

class CoverRubberbandPicker extends React.Component<
    CoverRubberbandPickerProps,
    CoverRubberbandPickerState
> {
    private changeRubberBand = (rubberBandColorId: any) => {
        const selectedRubberBand = this.props.validRubberBands.find(
            (x) => x.id === rubberBandColorId,
        );

        if (!selectedRubberBand) {
            return;
        }

        this.props.updateRubberband(selectedRubberBand.articleNumber);
    };

    public render() {
        const { calendar, validRubberBands, Binding_Rubberband } = this.props;

        let selectedItem = validRubberBands.find(
            (x) => x.articleNumber === calendar.rubberband,
        );

        if (!selectedItem) {
            const defaultRubberBand = DefaultRubberbandsList.find(
                (x) => x.calendarSize === this.props.calendar.calendarSize,
            );

            if (defaultRubberBand) {
                this.changeRubberBand(defaultRubberBand.value.id);
                selectedItem = defaultRubberBand.value;
            }
        }

        const selectedColor = selectedItem ? selectedItem.id : null;

        return (
            <>
                <label className={styles.subLabel}>{Binding_Rubberband}</label>
                <ZentaColorPicker
                    selectedItemId={selectedColor}
                    colors={validRubberBands.map((x) => {
                        return {
                            id: x.id,
                            hexColor: x.hexColor,
                            applyGradient: x.isMetalic,
                        } as ZentaColorPickerItem;
                    })}
                    onClick={this.changeRubberBand}
                    colorsWithBorder={[2]}
                />
            </>
        );
    }
}

export default CoverRubberbandPicker;
